import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { LaunchDialogService } from '../../../../core/modal';
import { ActionButtonModule } from '../../../../shared/components/action-button';
import { DatePickerModule } from '../../../../shared/components/date-picker/date-picker.module';
import { DropdownModule } from '../../../../shared/components/dropdown/dropdown.module';
import { ModalModule } from '../../../../shared/components/modal/modal.module';
import { RadioModule } from '../../../../shared/components/radio/radio.module';
import { ReactiveFormCheckboxSliderModule } from '../../../../shared/components/reactive-forms-input/reactive-form-checkbox-slider/reactive-form-checkbox-slider.module';
import { ReactiveFormCheckboxModule } from '../../../../shared/components/reactive-forms-input/reactive-form-checkbox/reactive-form-checkbox.module';
import { ReactiveFormInputFieldModule } from '../../../../shared/components/reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { ReactiveFormTextareaModule } from '../../../../shared/components/reactive-forms-input/reactive-form-textarea/reactive-form-textarea.module';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { pdpInquiryModalLayoutConfig } from './pdp-inquiry-modal-layout.config';
import { PdpInquiryModalComponent } from './pdp-inquiry-modal.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ReactiveFormInputFieldModule,
    ReactiveFormTextareaModule,
    ReactiveFormCheckboxSliderModule,
    ReactiveFormCheckboxModule,
    DatePickerModule,
    ModalModule,
    NzIconModule,
    I18nModule,
    ActionButtonModule,
    DropdownModule,
    RadioModule,
    PipesModule,
    NgbTooltipModule,
    KeyboardFocusModule,
  ],
  declarations: [PdpInquiryModalComponent],
  exports: [PdpInquiryModalComponent],
})
export class PdpInquiryModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(pdpInquiryModalLayoutConfig);
  }
}
